import React from 'react';

const Notifications = () => {
    return (
    // TODO : creation de tache - changmnt de statut - partage d'un doc - client assigne une tache a un expert [cas de one to many experts]
        <div
            style={{
                position: 'relative',
                top: '110px', //* comment this top if you want this navBar to replace the other (older)
                zIndex: '10'
            }}
        >
        Notifications
        TODO : creation de tache - changmnt de statut - partage d un doc - client assigne une tache a un expert [cas de one to many experts]
        </div>
    );
};

export default Notifications;